import { createAction } from "@reduxjs/toolkit";

export const getProfileAction = createAction("getProfile", (Request: any) => ({
    payload: {Request },
}));
export const editProfileAction = createAction("editProfile", (id:any,Request: any) => ({
    payload: {id,Request },
}));
export const patientListAction = createAction("patientList", (Request: any, onSuccess?:Function, onError?:Function) => ({
    payload: {Request,onSuccess,onError },
}));
export const createPatientAction = createAction("createPatient", (Request: any, onSuccess?:Function, onError?:Function) => ({
    payload: {Request,onSuccess,onError},
}));
export const updatePatientAction = createAction("updatePatient", (Request: any, onSuccess?:Function, onError?:Function) => ({
    payload: {Request,onSuccess,onError},
}));
export const addFamilyMemberAction = createAction("addFamilyMember", (Request: any, onSuccess?:Function, onError?:Function) => ({
    payload: {Request,onSuccess,onError},
}));
export const updateFamilyMemberAction = createAction("updateFamilyMember", (Request: any,onSuccess?:Function, onError?:Function) => ({
    payload: {Request,onSuccess,onError},
}));
export const deleteMemberAction = createAction("deleteMember", (Request: any,onSuccess?:Function, onError?:Function) => ({
    payload: {Request,onSuccess,onError},
}));
export const orderListAction = createAction("orderList", (Request: any) =>  ({
    payload: {Request },
}));
export const addressListAction = createAction("addressList", (Request: any) => ({
    payload: {Request },
}));
export const addAddressAction = createAction("addAddress", (Request: any, onSuccess?:Function, onError?:Function) => ({
    payload: {Request,onSuccess,onError},
}));
export const updateAddressAction = createAction("updateAddress", (Request: any,onSuccess?:Function, onError?:Function) => ({
    payload: {Request,onSuccess,onError},
}));
export const termConditionAction = createAction("termCondition", (Request: any) => ({
    payload: {Request },
}));
export const reportListAction = createAction("reportList", (Request: any) => ({
    payload: {Request },
}));
export const paymentHistoryAction = createAction("paymentHistory", (Request: any) => ({
    payload: {Request },
}));
export const userActivityLogAction = createAction("userActivityLog", (Request: any) => ({
    payload: {Request },
}));
export const profileMasterAction = createAction("profileMaster", (Request: any) => ({
    payload: {Request },
}));
export const cityListAction = createAction("cityList", (Request: any, onSuccess?:Function, onError?:Function) => ({
    payload: {Request,onSuccess,onError},
}));
export const stateListAction = createAction("stateList", (Request: any,onSuccess?:Function, onError?:Function) => ({
    payload: {Request },
}));
export const pincodeListAction = createAction("pincodeList", (Request: any, onSuccess?:Function, onError?:Function) => ({
    payload: {Request,onSuccess,onError},
}));
export const cancelBookingAction = createAction("cancelBooking", (Request: any,onSuccess?:Function, onError?:Function) => ({
    payload: {Request,onSuccess,onError},
}));
export const refundBookingAction = createAction("refundBooking", (Request: any,onSuccess?:Function, onError?:Function) => ({
    payload: {Request,onSuccess,onError},
}));
export const bookingDetailsAction = createAction("bookingDetails", (Request: any, onSuccess?:Function, onError?:Function) => ({
    payload: {Request,onSuccess,onError},
}));
export const cartListAction = createAction("cartList", (Request: any, onSuccess?:Function, onError?:Function) => ({
    payload: {Request,onSuccess,onError},
}));
export const refundDetailsAction = createAction("refundDetails", (Request: any, onSuccess?:Function, onError?:Function) => ({
    payload: {Request,onSuccess,onError},
}));